import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useTranslation } from "react-i18next";
import { Logger } from "@base-provider";
import getSchema from "./schema";
import uischema from "./uischema.json";
//core imports
import SFCard, {
  SFCardBody,
} from "../../../components/card";
import {
  SFGridContainer,
  SFGridItem,
} from "../../../components/grid";
import SFContainer from "../../../components/container";
import { SFFormBuilder } from "../../../components/formBuilder";
import SFTypography from "../../../components/typography";

const SelectEntityStep = forwardRef((props, ref) => {
  const [selectState, setSelectState] = useState({
    entities: [],
    selected: {},
  });
  const [schema, setSchema] = useState({});
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    onStepChange: stepChangeHandler,
    onLoad: loadStepHandler,
  }));

  useEffect(() => {
    const getSchemaDef = async () => {
      const data = await getSchema();
      return data;
    };
    getSchemaDef()
      .then((data) => {
        setSchema(data.schema);
      })
      .catch((err) =>
        Logger.of("App.uploadFile.getSchema.error").error({
          err,
        })
      );
  }, []);

  const entitySelectHandler = (option) => {
    setSelectState((curState) => ({ ...curState, selected: option }));
  };

  const stepChangeHandler = (data) => {
    Logger.of("App.uploadFile.selectEntityStep.changeStepHandler").info({
      data,
    });
    if (selectState.selected && Object.keys(selectState.selected).length !== 0) {
      return { entity: selectState.selected };
    }
  };

  const loadStepHandler = (stepperData) => {
    const stepData = stepperData.data.find(
      (x) => x.step === stepperData.activeStep
    ).data;
    Logger.of("App.uploadFile.selectEntityStep.loadStepHandler").info({
      stepperData,
    });
    if (stepData.entity) {
      setSelectState((curState) => ({
        ...curState,
        selected: stepData.entity,
      }));
    }
  };

  return (
    <SFGridContainer>
      <SFGridItem xs={12}>
        <SFTypography variant="h4">{t("fileUploadWizard.selectEntity")}</SFTypography>
      </SFGridItem>
      <SFGridItem xs={12}>
        <SFCard>
          <SFCardBody>
            <SFContainer>
              <SFGridContainer>
                <SFGridItem xs={12} sm={6} md={4}>
                  <SFFormBuilder
                    schema={schema}
                    uischema={uischema[0]}
                    data={selectState.selected}
                    onChange={(data) => entitySelectHandler(data)}
                  />
                </SFGridItem>
              </SFGridContainer>
            </SFContainer>
          </SFCardBody>
        </SFCard>
      </SFGridItem>
    </SFGridContainer>
  );
});

export default SelectEntityStep;
